export const buttonBaseStyle = {
  fontFamily: 'instrumentSans',
  fontWeight: 'semibold',
  borderRadius: '8px',
  cursor: 'pointer',
  _disabled: {
    opacity: 0.6,
  },
};

const buttonTheme = {
  baseStyle: buttonBaseStyle,
  variants: {
    globalNavigation: {
      fontFamily: 'Barlow',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      width: 20,
      height: '58px',
      padding: 0,
      background: 'transparent',
      color: 'navigation.globalMuted',
      borderRadius: 0,
      _hover: { background: 'whiteAlpha.100', color: 'white' },
    },
    navigationProfile: {
      fontFamily: 'Barlow',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0.5,
      width: 20,
      height: 14,
      padding: 0,
      background: 'whiteAlpha.100',
      color: 'white',
      borderRadius: 0,
      _hover: { background: 'whiteAlpha.200' },
    },
    navigationVariant: {
      width: 'full',
      height: '34px',
      minHeight: '34px',
      flexShrink: 0,
      marginTop: 3,
      paddingX: 2.5,
      paddingY: 0,
      borderWidth: '1px',
      borderColor: 'navigation.contextBorder',
      borderRadius: 0,
      justifyContent: 'space-between',
      background: 'transparent',
      fontFamily: 'instrumentSans',
      fontSize: '13px',
      fontWeight: 'medium',
      textAlign: 'left',
      lineHeight: 'normal',
      _hover: { background: 'navigation.contextActiveBackground' },
    },
    entityDirectoryPrimary: {
      background: 'entityDirectory.primaryBackground',
      color: 'entityDirectory.primaryText',
      _hover: {
        filter: 'brightness(0.94)',
        _disabled: {
          background: 'entityDirectory.primaryBackground',
          color: 'entityDirectory.primaryText',
          filter: 'none',
        },
      },
      _disabled: {
        background: 'entityDirectory.primaryBackground',
        color: 'entityDirectory.primaryText',
        opacity: 0.5,
        _hover: {
          background: 'entityDirectory.primaryBackground',
          color: 'entityDirectory.primaryText',
          filter: 'none',
        },
      },
    },
    entityDirectoryMenu: {
      background: 'transparent',
      color: 'entityDirectory.secondaryText',
      minW: 0,
      padding: 0,
      _hover: { background: 'entityDirectory.raisedSurface' },
    },
    entityDirectorySecondary: {
      background: 'entityDirectory.secondaryBackground',
      border: '1px solid',
      borderColor: 'entityDirectory.secondaryBorder',
      color: 'entityDirectory.secondaryText',
      _hover: {
        background: 'entityDirectory.raisedSurface',
      },
    },
    formInlineCreate: {
      alignSelf: 'flex-start',
      background: 'entityDirectory.secondaryBackground',
      border: '1px solid',
      borderColor: 'entityDirectory.secondaryBorder',
      color: 'entityDirectory.secondaryText',
      fontSize: '11px',
      height: '32px',
      marginTop: 1,
      minWidth: 0,
      paddingX: 3,
      textTransform: 'none',
      _hover: {
        background: 'entityDirectory.raisedSurface',
      },
    },
    entityDirectoryFilter: {
      background: 'transparent',
      border: '1px solid',
      borderColor: 'entityDirectory.secondaryBorder',
      color: 'entityDirectory.secondaryText',
      _hover: { background: 'entityDirectory.raisedSurface' },
    },
    entityDirectoryFilterActive: {
      background: 'entityDirectory.primaryBackground',
      border: '1px solid',
      borderColor: 'entityDirectory.primaryBackground',
      color: 'entityDirectory.primaryText',
      _hover: { filter: 'brightness(0.94)' },
    },
    entityDirectoryPagination: {
      background: 'entityDirectory.raisedSurface',
      border: '1px solid',
      borderColor: 'entityDirectory.secondaryBorder',
      color: 'entityDirectory.secondaryText',
      _hover: { background: 'entityDirectory.inputBackground' },
      _active: {
        background: 'entityDirectory.primaryBackground',
        borderColor: 'entityDirectory.primaryBackground',
        color: 'entityDirectory.primaryText',
      },
      _disabled: {
        cursor: 'not-allowed',
        opacity: 0.6,
      },
    },
    'texas-login': {
      backgroundColor: 'white',
      color: 'black',
      _hover: {
        opacity: 0.7,
        _disabled: {
          bg: 'whiteAlpha.700',
        },
      },
    },
    texas: {
      backgroundColor: 'texas.bg.900',
      _hover: {
        backgroundColor: 'texas.bg.700',
        color: 'white',
      },
      _light: {
        color: 'white',
        _hover: {
          backgroundColor: 'texas.bg.700',
          _disabled: { backgroundColor: 'texas.bg.900' },
        },
      },
    },
    'texas-solid': {
      backgroundColor: 'texas.sand.100',
      color: 'white',
      _hover: {
        backgroundColor: 'texas.sand.50',
        _disabled: { backgroundColor: 'texas.sand.100' },
      },
      _light: {
        backgroundColor: 'texas.burntSienna.500',
        color: 'white',
        _hover: {
          backgroundColor: 'texas.burntSienna.100',
          _disabled: { backgroundColor: 'texas.burntSienna.500' },
        },
      },
    },
    'texas-light': {
      backgroundColor: 'whiteAlpha.200',
      color: 'white',
      _hover: {
        backgroundColor: 'whiteAlpha.300',
        _disabled: { backgroundColor: 'whiteAlpha.200' },
      },
      _light: {
        backgroundColor: 'blackAlpha.200',
        color: 'black',
        _hover: {
          backgroundColor: 'blackAlpha.300',
          _disabled: {
            backgroundColor: 'blackAlpha.200',
          },
        },
      },
    },
    'texas-outline': {
      border: '2px solid',
      borderColor: 'texas.bg.800',
      color: 'white',
      _hover: {
        borderColor: 'texas.bg.700',
      },
      _light: {
        color: 'black',
        borderColor: 'gray.200',
        _hover: {
          borderColor: 'black',
        },
      },
    },
    'texas-outline-light': {
      backgroundColor: 'none',
      border: '2px solid',
      borderColor: 'whiteAlpha.200',
      color: 'whiteAlpha.800',
      _hover: {
        color: 'white',
        background: 'whiteAlpha.100',
      },
      _light: {
        color: 'texas.bg.700',
        borderColor: 'blackAlpha.200',
        _hover: {
          color: 'texas.bg.900',
          backgroundColor: 'blackAlpha.50',
        },
      },
    },
    filter: {
      bg: 'transparent',
      border: '2px solid',
      _hover: {
        color: 'gray.100',
        _light: {
          color: 'gray.700',
        },
      },
    },
    pagination: {
      backgroundColor: 'none',
      border: '1px solid',
      borderColor: 'whiteAlpha.300',
      color: 'white',
      _hover: {
        background: 'whiteAlpha.200',
      },
      _active: { background: 'whiteAlpha.300' },
      _disabled: {
        opacity: 0.6,
        cursor: 'not-allowed',
      },
      _light: {
        color: 'black',
        borderColor: 'blackAlpha.100',
        _hover: {
          backgroundColor: 'blackAlpha.50',
        },
        _active: { background: 'blackAlpha.100' },
        _disabled: { _hover: { background: 'initial' } },
      },
    },
    widget: {
      h: 'auto',
      w: 'auto',
      alignItems: 'start',
      justifyContent: 'start',
      textAlign: 'start',
      whiteSpace: 'normal',
      color: 'white',
      backgroundColor: 'whiteAlpha.200',
      border: '1px solid',
      _hover: {
        backgroundColor: 'whiteAlpha.300',
        _disabled: { backgroundColor: 'whiteAlpha.200' },
      },
      _light: {
        backgroundColor: 'blackAlpha.200',
        color: 'black',
        _hover: {
          backgroundColor: 'blackAlpha.300',
          _disabled: {
            backgroundColor: 'blackAlpha.200',
          },
        },
      },
    },
    'ghost-dashed': {
      border: '1px solid',
      borderColor: 'gray.600',
      borderStyle: 'dashed',
      color: 'gray.200',
      flexGrow: 1,
      padding: '16px',
      _hover: { cursor: 'pointer', backgroundColor: 'texas.bg.800' },
      _light: {
        color: 'gray.500',
        borderColor: 'gray.500',
        _hover: {
          color: 'gray.600',
          backgroundColor: 'gray.50',
        },
      },
    },
    'texas-link': {
      border: 'none',
      color: 'white',
      width: 'fit-content',
      padding: '0 8px 0 8px',
      backgroundColor: 'transparent',
      _hover: { color: 'whiteAlpha.600' },
      _light: {
        color: 'blackAlpha.700',
        _hover: { backgroundColor: 'transparent', color: 'blackAlpha.800' },
      },
    },
    'texas-link-danger': {
      textDecoration: 'underline',
      color: 'texas.danger.100',
      _light: { color: 'red.600' },
    },
    'texas-link-light': {
      border: 'none',
      color: 'whiteAlpha.700',
      width: 'fit-content',
      padding: '0 8px 0 8px',
      backgroundColor: 'transparent',
      _hover: { color: 'white' },
      _light: {
        color: 'blackAlpha.600',
        _hover: { backgroundColor: 'transparent', color: 'blackAlpha.800' },
      },
    },
    'no-bg': {
      bg: 'transparent',
      color: 'gray.300',
      _hover: {
        bg: 'transparent',
        color: 'gray.100',
        _light: { color: 'gray.600' },
      },
    },
    'no-bg-dark': {
      bg: 'transparent',
      color: 'gray.300',
      _light: { color: 'gray.500' },
      _hover: {
        bg: 'transparent',
        color: 'gray.100',
        _light: { color: 'gray.900' },
      },
    },
    'comp-version': {
      h: 'auto',
      w: 'full',
      p: '2',
      borderRadius: '0',
      alignItems: 'start',
      backgroundColor: 'texas.bg.700',
      _hover: {
        backgroundColor: 'texas.bg.600',
        color: 'white',
      },
      _light: {
        color: 'black',
        bg: 'white',
        _hover: {
          backgroundColor: 'gray.10',
        },
      },
    },
    'avatar-badge': {
      borderRadius: 'full',
      width: '26px',
      height: '26px',
      minWidth: 'none',
      variant: 'outline',
      bg: 'white',
      color: 'black',
      border: '1px solid',
      borderColor: 'gray.50',
      _hover: {
        bg: 'whiteAlpha.900',
        transform: 'scale(1.1)',
      },
    },
    theme: {
      bg: '#42415e',
      color: '#d7bffa',
      border: '2px solid #504e73',
      _hover: {
        bg: '#494865',
        color: '#ece6f4',
        _light: {
          bg: '#ffe7e0',
        },
      },
      _light: {
        bg: '#ffece7',
        color: 'texas.burntSienna.500',
        borderColor: '#ffded5',
      },
    },
  },
};

export default buttonTheme;
